export default {
  // App root data
  data() {
    return {
      foo: 'bar'
    };
  },

  // App root methods
  methods: {
    doSomething() {// ...
    }

  },
  id: 'e74b0112eb',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div id="app">\n\n    <!-- Your main view, should have "view-main" class -->\n    <div class="view view-main view-init safe-areas" data-url="/"></div>\n\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};